import React, { useContext, useState, useEffect } from "react";
import {
  Footer,
  HeaderNavi,
  ScrollTop,
  MyPageLeftMenuStudent,
  Pagination,
} from "@components";
import { AuthContext } from "@context/AuthContext";
import { HeaderContext } from "@context/HeaderContext";
import { useNavigate, Link  } from "react-router-dom";
import { get } from "@utils/axios_api";
import { useQuery } from '@tanstack/react-query';



const MyLecturesStudent = () => {
  const { auth } = useContext(AuthContext);
  const { subMenu, setSubMenu } = useContext(HeaderContext);
  const navigate = useNavigate();
  /* ---------------- 상태 ---------------- */
  const [activeTab, setActiveTab] = useState("관리감독자정기교육");
  const [pageIndex, setPageIndex] = useState(1);
  const itemsPerPage = 10; // 페이지 당 항목 수

  /* ---------------- 탭 ↔ EDU_TYPE 매핑 ---------------- */
  const tabToEduClass = {
    관리감독자정기교육: "A",
    위험성평가담당자교육: "C",
    근로자안전교육: "B",
  };

  /* 탭 변경 핸들러 */
  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    setPageIndex(1); // 탭이 변경되면 페이지를 1로 초기화
  };

  /* 페이지 변경 핸들러 */
  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };

  /* ---------------- 탭 ↔ EDU_TYPE 매핑 ---------------- */// ★ 수정
  const fetchMyLectures = async (tab, pageIndex) => {
    const response = await get("/myStudentLectures", {
      params: {
        eduClass: tab,
        pageIndex,
        recordCountPerPage: itemsPerPage,
      },
    });
    return response;
  };



  /* useQuery를 사용하여 데이터 가져오기 */
  const { data, isLoading, isError } = useQuery({
    queryKey: ["myLecturesStudent", activeTab, pageIndex],
    queryFn: () => fetchMyLectures(tabToEduClass[activeTab], pageIndex),
    enabled: !!auth.isAuthenticated, // 세션 기반 호출
  });

  /* 로그인 여부 확인 */
  useEffect(() => {
    setSubMenu("나의 교육정보");
  }, [setSubMenu]);


  if (isLoading) {
    return <div>로딩 중...</div>;
  }

  if (isError) {
    return <div>오류가 발생했습니다</div>;
  }

  return (
    <>
      <ScrollTop />
      <main id="main" className="mainpage">
        <div>
          <div className="section main-contact">
            {/* 헤더 네비게이션 */}
            <HeaderNavi selectedCategory={subMenu} />

            <div className="sub-container">
              <div className="sub-layout">
                {/* 왼쪽 메뉴 */}
                <MyPageLeftMenuStudent />

                {/* 본문 컨텐츠 */}
                <div className="sub-contact">
                  <h3 className="border-bt">나의 교육정보</h3>

                  {/* 탭 메뉴 */}
                  <div className="tab">
                    <ul className="tabnav">
                      {[
                        "관리감독자정기교육",
                        "위험성평가담당자교육",
                        "근로자안전교육",
                      ].map((tabName) => (
                        <li key={tabName}>
                          <a
                            href="#!"
                            className={activeTab === tabName ? "active" : ""}
                            onClick={() => handleTabChange(tabName)}
                          >
                            {tabName}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <div className="tabcontent">
                      {/* 각 탭에 따른 콘텐츠 */}
                      <div>
                        {/* 테이블 */}
                        <div className="lineTop_tb01">
                          <table className="lineTop_tb">
                            <colgroup>
                              <col width="50px" />
                              <col width="250px" />
                              <col width="100px" />
                              <col width="100px" />
                              <col />
                              <col width="100px" />
                              <col />
                              <col />
                            </colgroup>
                            <thead>
                              <tr>
                                <th>번호</th>
                                <th>강의명</th>
                                <th>교육유형</th>
                                <th>강의날짜</th>
                                <th>강의상태</th>
                                <th>신청일시</th>
                                <th>신청상태</th>
                                <th>출석여부</th>
                                <th>이수여부</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data &&
                              data.resultList &&
                              data.resultList.length > 0 ? (
                                data.resultList.map((lecture, index) => (
                                  <tr key={lecture.lectureId}>
                                    <td>
                                      {index +
                                        1 +
                                        (pageIndex - 1) * itemsPerPage}
                                    </td>
                                    <td>
                                    <Link
                                      to={`/myLectures/myStudentLectures/${lecture.lectureId}`}
                                      state={{ subMenu: '나의 교육정보' }}  // 추가된 부분
                                    >                                           
                                  {lecture.lectureNm}
                                    </Link>
                                    </td>
                                      <td>{lecture.eduTypeNm}</td>
                                      <td>{lecture.lectureDate}</td>
                                      <td>{lecture.lectureStatusNm}</td>
                                      <td>
                                        {lecture.applyDt?.split(' ')[0]}<br />
                                        {lecture.applyDt?.split(' ')[1]}
                                      </td> 
                                      <td>{lecture.applyStatusNm ?? lecture.applyStatus}</td>
                                     <td>
                                      {lecture.attendanceYn === "Y"
                                        ? "출석"
                                        : lecture.attendanceYn === "N"
                                        ? "결석"
                                        : "출석대기"}
                                    </td>
                                      <td>{lecture.completeYn === "Y" ? "이수" : "미이수"}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="9">수강 내역이 없습니다.</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {/* 테이블 끝 */}
                      </div>
                      {/* Pagination 추가 */}
                      {data?.paginationInfo &&
                        data.paginationInfo.totalRecordCount > 0 && (
                          <Pagination
                            totalPages={Math.ceil(
                              data.paginationInfo.totalRecordCount /
                                data.paginationInfo.recordCountPerPage
                            )}
                            currentPage={pageIndex}
                            onPageChange={handlePageChange}
                            pageRangeDisplayed={5} // 필요에 따라 조정
                          />
                        )}
                    </div>
                  </div>
                  {/* 탭 메뉴 끝 */}
                </div>
                {/* 본문 컨텐츠 끝 */}
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
};

export default MyLecturesStudent;